// scrollIntoView is silently cancelled by CSS scroll-snap in some browsers,
// which killed every nav click. Compute the offset and use window.scrollTo.
export function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  const top =
    el.getBoundingClientRect().top +
    (window.scrollY || document.documentElement.scrollTop || 0);
  window.scrollTo({ top, behavior: "smooth" });
}
